import { Github, Mail, Lightbulb, BookOpen, BrainCircuit } from "lucide-react"

const AboutPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">About Mnemonic Hub</h1>
          <div className="h-1 w-20 bg-gradient-to-r from-blue-500 via-green-500 to-orange-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600">
            Helping JEE students master complex concepts through powerful memory techniques
          </p>
        </div>

        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-4">Our Mission</h2>
          <p className="text-gray-700 mb-4">
            Mnemonic Hub was created to help students preparing for JEE (Joint Entrance Examination) to memorize and
            understand complex concepts in Physics, Chemistry, and Mathematics through the power of mnemonics.
          </p>
          <p className="text-gray-700">
            We believe that with the right memory techniques, students can significantly improve their retention and
            recall of important formulas, concepts, and principles, leading to better performance in exams and a deeper
            understanding of the subjects.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-4">Features</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-blue-50 p-6 rounded-lg">
              <div className="flex justify-center mb-4">
                <div className="p-3 bg-blue-100 rounded-full">
                  <Lightbulb className="w-6 h-6 text-blue-600" />
                </div>
              </div>
              <h3 className="text-xl font-semibold text-center mb-2">Subject-Specific Mnemonics</h3>
              <p className="text-gray-700 text-center">
                Organized collection of mnemonics for Physics, Chemistry, and Mathematics.
              </p>
            </div>

            <div className="bg-green-50 p-6 rounded-lg">
              <div className="flex justify-center mb-4">
                <div className="p-3 bg-green-100 rounded-full">
                  <BookOpen className="w-6 h-6 text-green-600" />
                </div>
              </div>
              <h3 className="text-xl font-semibold text-center mb-2">Personalized Bookmarks</h3>
              <p className="text-gray-700 text-center">
                Save your favorite mnemonics for quick access during revision.
              </p>
            </div>


          </div>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-4">About the Creator</h2>
          <div className="bg-gray-50 p-6 rounded-lg">
            <p className="text-gray-700 mb-4">
              Mnemonic Hub was designed and developed by Biki Kalita, an educator passionate about making learning more
              effective and enjoyable for students preparing for competitive exams.
            </p>
            <p className="text-gray-700 mb-4">
              With years of experience in teaching JEE aspirants, Biki noticed that students often struggled with
              remembering complex formulas and concepts. This inspired the creation of Mnemonic Hub as a tool to help
              students leverage the power of mnemonics in their studies.
            </p>
            <div className="flex justify-center space-x-4 mt-6">
              <a
                href="https://github.com/Biki-dev"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-700 transition-colors"
              >
                <Github className="w-5 h-5" />
                <span>GitHub</span>
              </a>
              <a
                href="mailto:quotex99575@gmail.com"
                className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span>Contact</span>
              </a>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">Contribute</h2>
          <p className="text-gray-700 mb-4">
            Mnemonic Hub is an ongoing project, and we're always looking to expand our collection of mnemonics. If you
            have a helpful mnemonic for a JEE concept, we'd love to hear from you!
          </p>
          <p className="text-gray-700">
            Please reach out via email or GitHub to contribute your mnemonics or suggest improvements to the platform.
          </p>
        </section>
      </div>
    </div>
  )
}

export default AboutPage
